<div class="dashboardLink" *ngIf="isAuthenticated">
    <ul class="d-flex">
        <li>
            <span class="welcome">Welcome</span>
            <span class="userName">{{userName}}</span>
            <div class="userDropdwon">
                <ul>
                    <li>
                        <a routerLink="/user" id="nav-user" routerLinkActive="active"> User </a>
                    </li>
                    <li>
                        <a ui-sref="home" id="nav-signout" (click)="logout()"> Sign
                            out</a>
                    </li>
                </ul>
            </div>
        </li>
    </ul>
</div>
<nav class="navbar navbar-expand-xl navbar-custom-bar navbar-inverse">
    <a class="navbar-brand" href="#">
        <div class="headerLeft d-flex align-self-end">
            <div class="logoOne">
                <a href="#" class="mr-3">
                    <img src="../../../assets/homepage-images/Adobe_Logo.png" alt="Adobe" class="img-responsive" /></a>
            </div>
            <div class="logoTwo"><a routerLink="/home" routerLinkActive="active" id="nav-home"><img
                        src="../../../assets/homepage-images/Relay_logo.png" alt="Relay" class="img-responsive" /></a>
            </div>
        </div>
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation"
        [ngClass]="isAuthenticated ? 'mt-5' : 'mt-0'"
        >
        <span class="navbar-toggler-icon">
            <i class="fas fa-bars"></i>
        </span>
    </button>

    <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav ml-auto pr-lg-0">
            <li class="nav-item dropdown" *ngIf="isAuthenticated">
                <a class="nav-link dropdown-toggle" data-toggle="dropdown" id="nav-repo" aria-haspopup="true"
                    aria-expanded="false" routerLink="/endpoint" [queryParams]="{ page: 1, size: 15 }"
                    [class.active]="isRouteActive(['/endpoint', '/testcase', '/testsuite', '/mastersuite'])">
                    Functional Automation
                </a>
                <div class="dropdown-menu" aria-labelledby="nav-repo">
                    <a class="dropdown-item" routerLink="/endpoint" [queryParams]="{ page: 1, size: 15 }"
                        id="nav-endpoint" [class.active]="isRouteActive(['/endpoint'])"> Endpoint</a>
                    <a class="dropdown-item" routerLink="/testcase" [queryParams]="{ page: 1, size: 15 }"
                        id="nav-testcase" [class.active]="isRouteActive(['/testcase'])"> Testcase</a>
                    <a class="dropdown-item" routerLink="/testsuite" [queryParams]="{ page: 1, size: 15 }"
                        id="nav-testsuite" [class.active]="isRouteActive(['/testsuite'])"> Testsuite</a>
                    <a class="dropdown-item" routerLink="/mastersuite" [queryParams]="{ page: 1, size: 15 }"
                        id="nav-mastersuite" [class.active]="isRouteActive(['/mastersuite'])">
                        Mastersuite</a>
                </div>
            </li>

            <li class="nav-item dropdown" *ngIf="isAuthenticated">
                <a class="nav-link dropdown-toggle" routerLink="/performance" id="nav-perlab" routerLinkActive="active"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Performance Lab
                </a>
                <div class="dropdown-menu" aria-labelledby="nav-perlab">
                    <a class="dropdown-item" routerLink="/performance" id="nav-chaos-overview"> Overview</a>
                    <a class="dropdown-item d-flex" routerLink="/performance/loadTesting" id="nav-chaos-started"> Test
                        Manager</a>
                    <a class="dropdown-item" routerLink="/performance/loadTesting/queue"
                        [queryParams]="{ page: 1, size: 15 }" id="nav-chaos-overview"> Test Results</a>
                    <a class="dropdown-item d-flex" routerLink="/performance/loadTesting/compare" id="nav-chaos-started">
                        <span> Review Testability Comparison </span></a>
                </div>
            </li>


            <li class="nav-item dropdown" *ngIf="isAuthenticated">
                <a class="nav-link dropdown-toggle" routerLink="/chaos" id="nav-help" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    Chaos Simulator
                </a>
                <div class="dropdown-menu" aria-labelledby="nav-help">
                    <a class="dropdown-item" routerLink="/chaos/overview" id="nav-chaos-overview"> Overview</a>
                    <a class="dropdown-item d-flex" routerLink="/chaos/intermediate" id="nav-chaos-started"> <span>Getting  started</span></a>
                </div>
            </li>
            <li class="nav-item dropdown" *ngIf="isAuthenticated">
                <a class="nav-link dropdown-toggle" routerLink="/mobileAutomation" id="nav-mobileAutomation"
                    routerLinkActive="active" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Mobile Automation
                </a>
                <div class="dropdown-menu" aria-labelledby="nav-mobileAutomation">
                    <a class="dropdown-item" routerLink="/mobileAutomation/overview"
                        id="nav-chaos-overview">Overview</a>
                    <a class="dropdown-item d-flex" routerLink="/mobileAutomation/locator" id="nav-chaos-started">
                        <span>Mobile Locator</span></a>
                    <a class="dropdown-item d-flex" routerLink="/mobileAutomation/instruction"
                        id="nav-chaos-started"> <span>Instructions</span></a>
                    <a class="dropdown-item d-flex" routerLink="/mobileAutomation/executions" [queryParams]="{ platformType: 'MOBILE' }"
                        id="nav-chaos-started"> <span>Executions</span></a>
                </div>
            </li>
            <li class="nav-item dropdown" *ngIf="isAuthenticated">
                <a class="nav-link dropdown-toggle" routerLink="/desktopAutomation" id="nav-mobileAutomation"
                    routerLinkActive="active" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Desktop Automation
                </a>
                <div class="dropdown-menu" aria-labelledby="nav-mobileAutomation">
                    <a class="dropdown-item" routerLink="/desktopAutomation/overview"
                        id="nav-chaos-overview">Overview</a>
                    <a class="dropdown-item d-flex" routerLink="/desktopAutomation/locator" id="nav-chaos-started">
                        <span>Locator</span></a>
                    <a class="dropdown-item d-flex" routerLink="/desktopAutomation/instruction"
                        id="nav-chaos-started"> <span>Instruction</span></a>
                    <a class="dropdown-item d-flex" routerLink="/desktopAutomation/executions" [queryParams]="{ platformType: 'DESKTOP' }"
                        id="nav-chaos-started"> <span>Executions</span></a>
                </div>
            </li>
            <li class="nav-item dropdown" *ngIf="isAuthenticated">
                <a class="nav-link dropdown-toggle" routerLink="/history/testcase"
                    [queryParams]="{ page: 1, size: 15, executedBy: this.userData?.id, executionType: 'TEST_CASE' }"
                    id="nav-history"
                    [class.active]="isRouteActive(['/history', '/results/testcase', '/results/testsuite', '/results/mastersuite'])"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Execution History
                </a>
                <div class="dropdown-menu" aria-labelledby="nav-history">
                    <a class="dropdown-item" routerLink="/history/testcase" id="nav-history-testcase"
                        [queryParams]="{ page: 1, size: 15, executedBy: this.userData?.id, executionType: 'TEST_CASE' }"
                        [class.active]="isRouteActive(['/history/testcase', '/results/testcase'])">
                        Test Case</a>


                    <a class="dropdown-item" routerLink="/history/testsuite" id="nav-history-testsuite"
                        [queryParams]="{ page: 1, size: 15, executedBy: this.userData?.id, executionType: 'TEST_SUITE' }"
                        [class.active]="isRouteActive(['/history/testsuite', '/results/testsuite'])">
                        Test Suite</a>


                    <a class="dropdown-item" routerLink="/history/mastersuite" id="nav-history-mastersuite"
                        [queryParams]="{ page: 1, size: 15, executedBy: this.userData?.id, executionType: 'MASTER_SUITE' }"
                        [class.active]="isRouteActive(['/history/mastersuite', '/results/mastersuite'])">
                        Master Suite</a>
                </div>
            </li>
            <li class="nav-item dropdown" *ngIf="isAuthenticated">
                <a class="nav-link dropdown-toggle" href="http://example.com" id="navbarDropdownMenuLink6"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    More
                </a>

                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink6">
                    <a class="dropdown-item d-flex" routerLink="/help" id="nav-help" routerLinkActive="active"> Demo Videos</a>
                    <a class="dropdown-item" routerLink="/help/help-center" id="nav-help-center"
                        [class.active]="isRouteActive(['/help-center'])"> Help Center</a>
                    <a class="dropdown-item"
                        href="https://app.powerbi.com/groups/me/apps/2ef02564-a5c1-44c0-a05d-1fd7f6233cbf/reports/172e817a-49f2-4ed2-bf3b-58fd0b5e72de/ReportSectionc5ad66c9e48ee2282238?chromeless=true">
                        Dashboard</a>
                </div>
            </li>
            <li class="nav-item" *ngIf="!isAuthenticated">
                <a class="nav-link" href="#relay/help">Demo Videos</a>
            </li>
            <li class="nav-item" *ngIf="!isAuthenticated">
                <a class="nav-link"  (click)="login()" id="nav-home" routerLinkActive="active">Sign In</a>
            </li>
        </ul>
    </div>
</nav>